<template class="header">
	<component :is="layoutComponent">
		<router-view></router-view>
	</component>
</template>

<script>
export default {
	name: 'page-home',
	computed: {
		layoutComponent() {
			const layoutName = this.$route.meta.layout || 'layout-admin';
			return layoutName;
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/page-home.vue